const apiUrl = "https://kahoot-api-zcux.onrender.com/";

export default apiUrl;
